/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Debt_DescriptionInputs */

const en_case_section_debt_description = /** @type {(inputs: Case_Section_Debt_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outstanding debts and prescription period.`)
};

const pt_br2_case_section_debt_description = /** @type {(inputs: Case_Section_Debt_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débitos em aberto e prazo de prescrição.`)
};

/**
* | output |
* | --- |
* | "Outstanding debts and prescription period." |
*
* @param {Case_Section_Debt_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_debt_description = /** @type {((inputs?: Case_Section_Debt_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Debt_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_debt_description(inputs)
	return pt_br2_case_section_debt_description(inputs)
});